<template>
  <div class="c-tab">
    <!-- <div class="c-tab__toolbar left" style="left: 400px;">
      <slot name="notify"></slot>
    </div> -->
    <div class="c-tab__toolbar">
      <slot name="operate"></slot>
    </div>
    <el-tabs v-model="active" @tab-click="onTabClick">
      <el-tab-pane
        v-for="(item, index) in tabs"
        :key="index"
        :label="item.label"
        :name="`${index}`"
        lazy
      >
        <component :is="item.component"></component>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'c-tab',
  props: {
    tabs: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      active: this.$route.query.active
    }
  },
  watch: {
    '$route' (val) {
      this.active = val.query.active || '0'
    }
  },
  methods: {
    onTabClick (tab) {
      this.$nextTick(() => {
        tab.$children[ 0 ].$emit('init')
      })
      this.$router.push(
        `${this.$route.path}?active=${this.active}`
      )
    }
  }
}
</script>

<style lang="scss">
$nav-height: 50px;

@include b(c-tab) {
  background: #fff;
  position: relative;
  @include e(toolbar) {
    position: absolute;
    right: 20px;
    z-index: 10;
    top: 0;
    height: 50px;
    line-height: 50px;
  }
  @include b(el-tabs) {
    @include e(header) {
      margin: 0;
    }
    @include e(nav-wrap) {
      padding-left: 20px;
      &::after {
        height: 1px;
      }
    }
    @include e(nav) {
      [tabindex='0']:nth-of-type(2):last-of-type {
        display: none;
      }
    }
    @include e(item) {
      height: $nav-height;
      line-height: $nav-height;
    }
    @include e(content) {
      padding: 24px;
    }
    .c-table {
      padding: 0;
    }
  }
}
</style>
